// Events
import { COUNTDOWN_FINISHED } from 'events';
import { component } from 'picoapp';

// Utils
import choozy from 'utils/choozy';

export default component(async (node, ctx) => {
  const { endDate } = choozy(node);
  const sitePassword = node.id;
  let sitePasswordDecoded = '';
  try {
    sitePasswordDecoded = atob(sitePassword);
  } catch {
    sitePasswordDecoded = '';
  }

  node.removeAttribute('id');

  if (endDate) {
    ctx.on(COUNTDOWN_FINISHED(endDate.dataset.endDate), () => {
      window.location.reload();
    });
  }

  const successVideoWrapper = node.querySelector('[data-success-video]');
  const passwordInput = node.querySelector('input[name="password"]');

  if (successVideoWrapper && passwordInput) {
    const passwordForm = passwordInput.closest('form');
    const successVideo = successVideoWrapper.querySelector('video');
    const successVideoLarge = successVideoWrapper.querySelector('video:last-child');

    const onSuccessVideoEnded = () => {
      passwordForm.submit();
    };

    successVideo.addEventListener('ended', onSuccessVideoEnded);
    successVideoLarge.addEventListener('ended', onSuccessVideoEnded);

    passwordForm.addEventListener('submit', (e) => {
      e.preventDefault();

      const formData = new FormData(passwordForm);
      const password = formData.get('password');

      if (password) {
        const typedPassword = String(password);
        if (
          sitePasswordDecoded &&
          typedPassword.toLowerCase() === sitePasswordDecoded.toLowerCase()
        ) {
          successVideoWrapper.removeAttribute('hidden');

          if (window.matchMedia('(min-width: 1024px)').matches) {
            successVideoLarge.play().catch(onSuccessVideoEnded);
          } else {
            successVideo.play().catch(onSuccessVideoEnded);
          }
        } else {
          passwordForm.submit();
        }
      }
    });
  }
});
